import * as React from 'react';
import * as toastr from 'toastr';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import userActions from '../../user/userActions';

import CustomerNoteDetailsForm from './CustomerNoteDetailsForm';

interface Props {
	customer: UserDetails;
	className?: string;
	note: CustomerNote;
	notes: CustomerNote[];
	actions: any;
	history: any;
	match: any;
}
class CustomerNoteDetails extends React.Component<Props>  {
	componentDidMount() {
		if (this.props.match.params.pageId && this.props.match.params.pageId !== 'new') {
			this.props.actions.fetchCustomerNote(this.props.match.params.customerId, this.props.match.params.pageId);
		} else {
			this.props.actions.resetCustomerNote(this.props.match.params.customerId);
		}
	}

	onChange = (e: any) => {
		const note = {
			...this.props.note,
			[e.target.name]: e.target.value,
			customerId: this.props.match.params.customerId
		};

		this.props.actions.setCustomerNote(note);
	}

	onSave = () => {
		// tslint:disable-next-line
		console.log(this.props.match.params.customerId);
		const note = { ...this.props.note };
		if (!note.customerId) {
			note.customerId = this.props.match.params.customerId;
		}

		this.props.actions.saveCustomerNote(note)
			.then(() => {
				toastr.success('Saved');
				if (!window.location.href.includes('prospects')) {
					return this.props.history.push(`/admin/customers/${this.props.match.params.customerId}/notes`);
				} else {
					return this.props.history.push(`/admin/prospects/${this.props.match.params.customerId}/notes`);
				}
			});
	}

	render() {
		return (
			<div className={this.props.className}>
				<CustomerNoteDetailsForm note={this.props.note} onChange={this.onChange} onSave={this.onSave} />
			</div>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		notes: state.user.notes,
		note: state.user.note
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerNoteDetails);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerNoteDetails.tsx